import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { handleResponse } from 'src/functions/http-handler';

@Injectable({
  providedIn: 'root'
})
export class TaxInvoiceService {
  private _apiUrl: string;

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private logger: NGXLogger) {
    this._apiUrl = `${baseUrl}api/TaxInvoice`;
  }

  get(param: any) {
    return this.http.get(this._apiUrl, { params: param })
      .pipe(handleResponse<ITaxInvoice>(this.logger, 'retrieve tax-invoice'));
  }
}

export interface ITaxInvoice {
  currentMonthInvoice: number,
  previousInvoice: number,
}